import React, { useEffect, useMemo, useRef, useState } from "react"
import { useHistory } from 'react-router'
import { useQuery } from '../../utils'
import { useRecoilValue } from "recoil"
import { Header } from '../shared'
import InventoryOfPharmacy from './InventoryOfPharmacy'
import CheapestPriceProduct from "./CheapestPriceProduct"
import { accountDataState } from "../../recoil/account"
import usePharmacy from "../../hooks/pharmacy"
import { useAsync } from "../../utils/hooks"
import { PharmacyDetailModel } from "../../models"
import { getInventoryInPharmacy, getPharmacyInfoLocal } from "../../api"
import { getCountUnread } from "../../api"



const InventoryDashboard = () => {
    const { getCurrentDetailPharmacy } = usePharmacy()
    const getCurrentDetailPharmacyAsync = useAsync<PharmacyDetailModel>(getCurrentDetailPharmacy)
    const getCountUnreadAsync = useAsync(getCountUnread)
    const [countUnread, setCountUnread] = useState<number>(0)


    const query = useQuery()
    const history = useHistory()
    const tab = query.get('tab')
    const accountInfo = useRecoilValue(accountDataState)
    const adminId = useMemo(() => {
        if (accountInfo.loginSession.userLocalType === 'ADMIN') return accountInfo.doctor.mId
    }, [accountInfo])

    useEffect(() => {
        const pharmacyInfo = getPharmacyInfoLocal()
        if (pharmacyInfo) {
            getCurrentDetailPharmacyAsync.execute()
        } else {
            console.error("Not found pharmacy info");
        }
    }, [])

    useEffect(() => {
        if (!adminId) {
            getCountUnreadAsync.execute().then(res => {
                setCountUnread(res.data.count)
            });
        }
    }, [])


    return <div className='admin-dashboard'>
        <Header
            title={getCurrentDetailPharmacyAsync.value?.pharmacy.mName}
            subTitle={getCurrentDetailPharmacyAsync.value?.pharmacyAddress.mAddress}
            backTo="/admin-dashboard"
            disableBackTo={!adminId}
        />
        {!adminId && <div id="admin-menu" className="distributor-menu">
            <div className="container">
                <div className="menu-tabs">
                    <a onClick={() => history.push(`/inventory-dashboard?tab=inventories`)} className={`${tab === "inventories" && "active"}`} >Kho hàng nhà thuốc</a>
                    <a onClick={() => history.push(`/inventory-dashboard?tab=cheapestprice`)} className={`${tab === "cheapestprice" && "active"}`}> <span>Giá thấp nhất</span> {countUnread > 0 && <span className="count-red">{countUnread}</span>}</a>
                </div>
            </div>
        </div>}
        {tab === 'inventories' && <InventoryOfPharmacy />}
        {tab === 'cheapestprice' && <CheapestPriceProduct
            countUnread={countUnread}
            setCountUnread={setCountUnread}
        />}
    </div>
}

export default InventoryDashboard